module.exports = __webpack_public_path__ + "img/turnover_credits.c976b087.png";